<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
import mixin from "@/mixins/index";
import ProblemForm from "@/components/partials/ProblemForm/index";
import ComplaintsList from "@/components/partials/ComplaintsList/index";
import ChooseUserModal from "@/components/pages/Modals/ChooseUserModal/index";
import UserSearch from "@/components/partials/UserSearch/index";
import GLOBALS from "@/global/store";
import CitizenAppealsTable from "@/components/partials/CitizenAppealsTable/index";
const similarColumns = [
  {
    title: "No",
    key: "no",
    scopedSlots: { customRender: "number" },
    width: "5%",
  },
  {
    title: "Mətn",
    key: "text",
    scopedSlots: { customRender: "comptext" },
    width: "25%",
  },
  {
    title: "Ünvan",
    key: "address",
    scopedSlots: { customRender: "address" },
    width: "30%",
  },
  {
    title: "Müraciət sayı",
    key: "count",
    dataIndex: "appealCount",
    width: "10%",
  },
  { title: "Müraciət tarixi", key: "date", dataIndex: "dateStr", width: "15%" },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: "15%",
  },
];

export default {
  name: "NewRequest",
  mixins: [mixin],
  components: {
    "complaints-list": ComplaintsList,
    "chooseuser-modal": ChooseUserModal,
    "user-search": UserSearch,
    "problem-form": ProblemForm,
    "citizen-appeals": CitizenAppealsTable,
  },
  data() {
    return {
      prefixes: GLOBALS.PREFIXES,
      current: 0,
      oldDetails: [],
      selectedDetail: null,
      selUser: null,
      cuser: null,
      similarDetails: [],
      similarDetailsAll: [],
      submitButtonLoading: false,
      similarColumns,
      similarCompLoading: false,
      appeal: {
        citizen: null,
        details: [],
        note: null,
      },
      steps: [
        { index: 0, title: "Müraciət edən şəxs" },
        { index: 2, title: "Şikayətlar" },
      ],
    };
  },
  methods: {
    handleUSClear() {
      this.cuser = null;
    },
    next(e) {
      e.preventDefault();
      this.current++;
    },
    prev(e) {
      e.preventDefault();
      this.current--;
    },
    handleSave(det) {
      det.no = this.appeal.details.length;
      this.appeal.details.push(det);
    },
    clearSelectedDetail() {
      if (this.selectedDetail) {
        this.similarDetIds = this.similarDetIds.filter(
          (item) => item !== this.selectedDetail.id
        );
        this.similarDetails = this.similarDetailsAll.filter(
          (item) => this.similarDetIds.indexOf(item.id) === -1
        );
        this.selectedDetail = null;
      }
      this.$refs.problemform.prevProblem = null;
    },
    getSimilarDetails({ executiveId, streetKey, address }) {
      if (!executiveId && !streetKey && !address) {
        this.similarDetails = [];
        this.$refs.problemform.addressSpin = false;
        return;
      }
      if (streetKey) {
        streetKey = isNaN(parseInt(streetKey.substr(6)))
          ? null
          : parseInt(streetKey.substr(6));
      }
      this.similarCompLoading = true;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "problems/related",
        params: {
          keyword: address,
          streetId: streetKey,
          executiveId: executiveId,
          limit: !address ? 30 : null,
        },
      })
        .then((response) => {
          this.similarCompLoading = false;
          if (!response.data.error) {
            this.similarDetailsAll = response.data.data.entities;
            this.similarDetails = response.data.data.entities.filter(
              (item) => this.similarDetIds.indexOf(item.id) == -1
            );
          }
          if (this.tmpDetail.id && this.similarDetails.length == 0) {
            this.resetTmpDetail();
          }
          this.$refs.problemform.addressSpin = false;
        })
        .catch((err) => {
          this.$refs.problemform.addressSpin = false;
          this.similarCompLoading = false;
        });
    },
    handleUserFound(ulist) {
      if (ulist && ulist.length == 1) {
        this.cuser = ulist[0];
        this.$set(
          this.cuser,
          "prefix",
          this.cuser.mobilePhoneNumber
            ? this.cuser.mobilePhoneNumber.slice(0, 6)
            : null
        );
        this.$set(
          this.cuser,
          "phoneNumber",
          this.cuser.mobilePhoneNumber
            ? this.cuser.mobilePhoneNumber.slice(6)
            : null
        );
        this.$set(
          this.cuser,
          "hprefix",
          this.cuser.homePhoneNumber
            ? this.cuser.homePhoneNumber.slice(0, 6)
            : null
        );
        this.$set(
          this.cuser,
          "hphoneNumber",
          this.cuser.homePhoneNumber
            ? this.cuser.homePhoneNumber.slice(6)
            : null
        );
        this.$set(
          this.cuser,
          "wprefix",
          this.cuser.whatsapNumber ? this.cuser.whatsapNumber.slice(0, 6) : null
        );
        this.$set(
          this.cuser,
          "wphoneNumber",
          this.cuser.whatsapNumber ? this.cuser.whatsapNumber.slice(6) : null
        );
        this.getOldAppeals();
      } else if (ulist && ulist.length > 1) {
        this.usersList = ulist;
        this.selectionModalVis = true;
      } else this.cuser = null;
    },
    getOldAppeals() {
      if (!this.cuser) return;
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "requests/citizenRequests",
        params: {
          pin: this.cuser.pin,
          limit: this.oldDetPagination.pageSize,
          offset:
            this.oldDetPagination.current * this.oldDetPagination.pageSize -
            this.oldDetPagination.pageSize,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            this.oldDetails = response.data.data.entities;
            const pagination = { ...this.oldDetPagination };
            pagination.total = response.data.data.totalCount;
            this.oldDetPagination = pagination;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveAppeal() {
      if (!this.validateFields()) return;
      this.appeal.citizen = {
        pin: this.cuser.pin,
        mobilePhoneNumber:
          !this.cuser.prefix || !this.cuser.phoneNumber
            ? null
            : this.cuser.prefix + this.cuser.phoneNumber,
        homePhoneNumber:
          !this.cuser.hprefix || !this.cuser.hphoneNumber
            ? null
            : this.cuser.hprefix + this.cuser.hphoneNumber,
        whatsapNumber:
          !this.cuser.wprefix || !this.cuser.wphoneNumber
            ? null
            : this.cuser.wprefix + this.cuser.wphoneNumber,
        id: 0,
        address: this.cuser.address,
      };
      if (this.appeal.details.length > 0) {
        this.showConfirm(this.appeal);
      }
    },
    validateFields() {
      let result = true;
      if (!this.cuser) {
        this.$message.error("Müraciət edən şəxs şəxs təyin edilməyib");
        result = false;
      } else {
        if (
          this.cuser.prefix &&
          (!this.cuser.phoneNumber || this.cuser.phoneNumber.length < 7)
        ) {
          this.customValidator.phoneError =
            "Zəhmət olmasa mobil telefonu tam daxil edin";
          result = false;
        } else {
          this.customValidator.phoneError = null;
        }

        if (
          this.cuser.hprefix &&
          (!this.cuser.hphoneNumber || this.cuser.hphoneNumber.length < 7)
        ) {
          this.customValidator.hphoneError =
            "Zəhmət olmasa ev telefonu tam daxil edin";
          result = false;
        } else {
          this.customValidator.hphoneError = null;
        }

        if (
          this.cuser.wprefix &&
          (!this.cuser.wphoneNumber || this.cuser.wphoneNumber.length < 7)
        ) {
          this.customValidator.wphoneError =
            "Zəhmət olmasa whatsap nömrəsini tam daxil edin";
          result = false;
        } else {
          this.customValidator.wphoneError = null;
        }

        if (
          result &&
          !this.cuser.phoneNumber &&
          !this.cuser.hphoneNumber &&
          !this.cuser.wphoneNumber
        ) {
          this.customValidator.wphoneError =
            "Vətəndaşın ən azı bir Əlaqə nömrəsi daxil edilməlidir";
          result = false;
        } else if (result) {
          this.customValidator.wphoneError = null;
        }
      }
      if (!result) this.current = 0;
      if (!this.appeal.details || this.appeal.details.length == 0) {
        this.$message.error("Heç bir şikayət əlavə edilməyib");
        result = false;
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
